import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postYamahaCognitoTokenExchange: DocumentNode = gql`
  mutation PostYamahaCognitoTokenExchange($input: YamahaCognitoTokenExchangeInput!, $productName: OutputLoginProductName) {
    postYamahaCognitoTokenExchange(input: $input, productName: $productName) {
      apiKey
      refreshToken
      cognitoTokens {
        idToken
        accessToken
        refreshToken
      }
      error
    }
  }
`

export default postYamahaCognitoTokenExchange
